import React, { Fragment, useState } from "react";
import Button from "../../../../../common/Button";
import { Menu, Transition } from "@headlessui/react";
import { ReactSVG } from "react-svg";
import clsx from "clsx";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
const Header = ({ text }) => (
  <p className="text-teal-300 text-[20px] leading-[20px] rounded-t-[12px] p-[20px] font-bold bg-teal-25">
    {text}
  </p>
);

const BackButton = ({ onClick, label }) => (
  <button onClick={onClick} className="flex items-center">
    <img src="/icons/arrow-left.svg" className="w-[20px]" alt="Back" />
    <span className="text-gray-800 ml-2 font-semibold">{label}</span>
  </button>
);

const Section = ({ header, children, onBack, backLabel }) => (
  <div className="flex flex-col rounded-t-[12px] h-full overflow-hidden">
    <Header text={header} />
    <div className="flex flex-col p-[20px] h-full overflow-auto">
      <BackButton onClick={onBack} label={backLabel} />
      <div className="mt-6">{children}</div>
      <p className="self-start justify-end mt-auto text-[14px] text-gray-600">
        Reference: medSask
      </p>
    </div>
  </div>
);

const PharmacologicalCard = ({
  data,
  prescribedMedication = {},
  onAddClick = () => {},
  onEditClick = () => {},
  onDeleteClick = () => {},
  disabled = false,
  inEffectiveClick = () => {},
  noInEffective = false,
  isAddOn = false,
}) => {
  const [activeItem, setActiveItem] = useState("");
  const [activePopulationItem, setActivePopulationItem] = useState("");
  const [populationBackLabel, setPopulationBackLabel] = useState("");

  const [isBlueBorder, setIsBlueBorder] = useState(false);
  const [isGrayBorder, setIsGrayBorder] = useState(false);
  const [viewedDrugs, setViewedDrugs] = useState([]);
  const handleButtonClick = (item) => {
    setActiveItem(item);
    //setClickedItems((prev) => ({ ...prev, [item]: true }));
  };

  const renderContent = () => {
    switch (activeItem) {
      case "clinicalPoints":
        return (
          <Section
            header={data.header}
            onBack={() => setActiveItem("")}
            backLabel="Clinical Points - Powered by medSask"
          >
            {data.clinicalPoints()}
          </Section>
        );
      case "specialPopulations":
        return (
          <>
            {data.specialPopulationPoints !== undefined && (
              <Section
                header={data.header}
                onBack={() => setActiveItem("")}
                backLabel="Special Populations - Powered by medSask"
              >
                {data.specialPopulationPoints()}
              </Section>
            )}

            {data.specialPopulationPoints === undefined && (
              <>
                {activePopulationItem === "" && (
                  <>
                    <Header text={data.header} />
                    <div className="flex flex-col p-[20px] h-full overflow-auto">
                      <BackButton
                        onClick={() => setActiveItem("")}
                        label="Special Populations - Powered by medSask"
                      />
                      <p className="mt-6 text-[14px] text-gray-700 font-bold">
                        {data.populationLabel}
                      </p>
                      {data.pregnancy !== undefined && (
                        <button
                          onClick={() => {
                            setActivePopulationItem("Pregnancy");
                          }}
                          className="flex items-center justify-between p-[20px] mt-[10px] bg-gray-20 rounded-[10px]"
                          aria-label="Show Clinical Points"
                        >
                          <p className="text-gray-800 text-[18px] leading-[20px] font-semibold">
                            Pregnancy
                          </p>
                          <img
                            src="/icons/arrow-right.svg"
                            className="max-h-[13px]"
                            alt="Arrow Right"
                          />
                        </button>
                      )}
                      {data.breastfeeding !== undefined && (
                        <button
                          onClick={() =>
                            setActivePopulationItem("Breastfeeding")
                          }
                          className="flex items-center justify-between p-[20px] mt-[10px] bg-gray-20 rounded-[10px]"
                          aria-label="Show Clinical Points"
                        >
                          <p className="text-gray-800 text-[18px] leading-[20px] font-semibold">
                            Breastfeeding
                          </p>
                          <img
                            src="/icons/arrow-right.svg"
                            className="max-h-[13px]"
                            alt="Arrow Right"
                          />
                        </button>
                      )}
                      {data.pediatrics !== undefined && (
                        <button
                          onClick={() => setActivePopulationItem("Pediatrics")}
                          className="flex items-center justify-between p-[20px] mt-[10px] bg-gray-20 rounded-[10px]"
                          aria-label="Show Clinical Points"
                        >
                          <p className="text-gray-800 text-[18px] leading-[20px] font-semibold">
                            Pediatrics
                          </p>
                          <img
                            src="/icons/arrow-right.svg"
                            className="max-h-[13px]"
                            alt="Arrow Right"
                          />
                        </button>
                      )}
                      <p className="self-start justify-end mt-auto text-[14px] text-gray-600">
                        Reference: medSask
                      </p>
                    </div>
                  </>
                )}
                {activePopulationItem !== "" && (
                  <Section
                    header={data.header}
                    onBack={() => setActivePopulationItem("")}
                    backLabel={activePopulationItem}
                  >
                    {activePopulationItem === "Pregnancy" && data.pregnancy()}
                    {activePopulationItem === "Breastfeeding" &&
                      data.breastfeeding()}
                    {activePopulationItem === "Pediatrics" && data.pediatrics()}
                  </Section>
                )}
              </>
            )}
          </>
        );
      default:
        return (
          <div className="flex flex-col z-10 rounded-t-[12px] h-full overflow-hidden ">
            <Header text={data.header} />
            <div className="flex flex-col p-[20px] h-full overflow-auto">
              <p className="text-gray-800 font-semibold text-[18px] leading-[24px]">
                {data.subheader}
              </p>
              <p className="text-gray-800 font-medium text-[16px] leading-[24px]">
                {data.smallHeader}
              </p>
              <button
                onClick={() => handleButtonClick("clinicalPoints")}
                className="flex items-center justify-between p-[20px] mt-[20px] bg-gray-20 rounded-[10px]"
                aria-label="Show Clinical Points"
              >
                <p className="text-gray-800 text-[18px] leading-[20px] font-semibold">
                  Clinical Points
                </p>
                <img
                  src="/icons/arrow-right.svg"
                  className="max-h-[13px]"
                  alt="Arrow Right"
                />
              </button>
              <button
                onClick={() => handleButtonClick("specialPopulations")}
                className="flex items-center justify-between p-[20px] mb-[98px] mt-[10px] bg-gray-20 rounded-[10px]"
                aria-label="Show Special Populations"
              >
                <p className="text-gray-800 text-[18px] leading-[20px] font-semibold">
                  Special Populations
                </p>
                <img
                  src="/icons/arrow-right.svg"
                  className="max-h-[13px]"
                  alt="Arrow Right"
                />
              </button>
            </div>
            <div
              className={`flex items-center justify-between border-t-[1px] h-[108px] border-gray-100 p-[20px] ${
                prescribedMedication?.medicationName
                  ? viewedDrugs?.includes(prescribedMedication?.medicationName)
                    ? "bg-teal-25 h-[140px]" : "bg-teal-25 h-[110px]" : "h-[88px]"
              }`}
            >
              <div className="flex flex-col">
                <p className="text-gray-800 text-[14px] leading-[14px] font-medium">
                  Prescription:
                </p>

                <p
                  className={`text-gray-800 text-[16px] leading-[16px] mt-2 ${
                    prescribedMedication?.medicationName
                      ? "font-semibold"
                      : "font-medium"
                  } capitalize`}
                >
                  {prescribedMedication?.medicationName
                    ? prescribedMedication?.medicationName +
                      " " +
                      prescribedMedication?.route
                    : "No prescription added."}
                  {}
                </p>

                {prescribedMedication?.medicationName &&
                  prescribedMedication?.medicationGenCodeType !==
                    "Sentence" && (
                    <>
                      {" "}
                      <p className="text-gray-800 text-[16px] leading-[16px] mt-1 font-semibold capitalize">
                        {prescribedMedication?.dosage}{" "}
                        {prescribedMedication?.frequency}{" "}
                        {prescribedMedication?.prn ? "As needed" : ""}
                      </p>
                      <div className="grid grid-cols-2">
                        <p>QTY: {prescribedMedication.dispenseQuantity}</p>
                        <p>
                          Refills:{" "}
                          {prescribedMedication.refills
                            ? prescribedMedication.refills
                            : 0}
                        </p>
                      </div>
                      {viewedDrugs?.includes(
                        prescribedMedication?.medicationName
                      ) && (
                        <>
                          {prescribedMedication.duration && (
                            <div>
                              <p>Duration: {prescribedMedication.duration} {prescribedMedication.unit}</p>
                            </div>
                          )}
                          {prescribedMedication.comments && (
                            <div>
                              <p>{prescribedMedication.comments}</p>
                            </div>
                          )}
                        </>
                      )}
                    </>
                  )}
              </div>

              {prescribedMedication?.medicationName ? (
                <div className="flex flex-col justify-center items-center gap-2">
                  <Menu as="div" className="relative inline-block text-left">
                    <div>
                      <Menu.Button>
                        <ReactSVG
                          src={`/icons/three-dots-big.svg`}
                          className={`flex text-black !items-center w-5`}
                        />
                      </Menu.Button>
                    </div>
                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform translate-y-2 opacity-0 scale-95"
                      enterTo="transform translate-y-0 opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform translate-y-0 opacity-100 scale-100"
                      leaveTo="transform translate-y-2 opacity-0 scale-95"
                    >
                      <Menu.Items className="absolute right-0 bottom-0 mt-2 mr-10 w-24 origin-bottom-right bg-white divide-y divide-gray-20 rounded-md shadow-lg ring-1 ring-black ring-opacity-5">
                        <Menu.Item>
                          <button
                            className="block w-full text-left px-3 py-3 border-b border-b-gray-20 hover:bg-gray-100"
                            onClick={() => {
                              onEditClick(prescribedMedication);
                            }}
                          >
                            Edit
                          </button>
                        </Menu.Item>
                        <Menu.Item>
                          <button
                            className="block w-full text-left px-3 py-3 border-b border-b-gray-20 hover:bg-gray-100"
                            onClick={() => {
                              onDeleteClick(prescribedMedication);
                            }}
                          >
                            Delete
                          </button>
                        </Menu.Item>
                      </Menu.Items>
                    </Transition>
                  </Menu>
                  {(prescribedMedication.duration ||
                    prescribedMedication.comments) && (
                    <ChevronDownIcon
                      className={`w-4 h-4 ${
                        viewedDrugs?.includes(
                          prescribedMedication?.medicationName
                        )
                          ? "-rotate-180"
                          : ""
                      }`}
                      onClick={() => {
                        setViewedDrugs(
                          !viewedDrugs?.includes(
                            prescribedMedication?.medicationName
                          )
                            ? [
                                ...viewedDrugs,
                                prescribedMedication?.medicationName,
                              ]
                            : viewedDrugs?.filter(
                                (x) =>
                                  x !== prescribedMedication?.medicationName
                              )
                        );
                      }}
                    />
                  )}
                </div>
              ) : (
                <Button
                  text="Add"
                  iconUrl="/icons/add.svg"
                  onClick={onAddClick}
                  iconBefore
                  type="primary"
                  className="w-fit min-w-[120px] !rounded-[20px] h-[40px]"
                />
              )}
            </div>
          </div>
        );
    }
  };
  return (
    <div
      disabled={disabled}
      className={clsx(
        "flex flex-col rounded-[20px] relative w-full transition-colors duration-300 p-[20px] border-[6px] min-w-[540px] max-w-[540px]",
        {
          "opacity-40 pointer-events-none": disabled,
          "border-REELTeal border-dashed": isBlueBorder || !isAddOn, // REELTeal when hovered or no add-on
          "border-gray-50 border-dashed": isAddOn && !isBlueBorder, // Gray border for add-ons without hover
          "hover:border-gray-400 hover:border-dashed": isAddOn && !isBlueBorder, // Gray border for add-ons with hover
          "border-teal-75": !isBlueBorder && !isAddOn, // Teal when not hovered and not add-on
          "hover:border-REELTeal hover:border-dashed": !isAddOn, // Hover effect if not add-on
          "mr-[40px] ": isAddOn, // Margin and overflow for add-on
          "mr-[200px]": !isAddOn, // Larger margin when not add-on
        }
      )}
      onMouseEnter={() =>
        !isAddOn ? setIsBlueBorder(true) : setIsGrayBorder(true)
      }
      onMouseLeave={() => {
        setIsBlueBorder(false);
        setIsGrayBorder(false);
      }}
    >
      <div className="flex flex-col rounded-[12px] bg-white z-10 border-[1px] border-gray-20 shadow-custom h-[480px] overflow-auto">
        {renderContent()}
      </div>
      {isAddOn ? (
        <svg
          width="278"
          height="517"
          viewBox="0 0 278 517"
          className="absolute right-[-16px] scale-[1.035] top-0 z-0 "
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M277.437 256.586V40.8203C277.437 18.7289 259.528 0.820312 237.437 0.820312H40.6562C18.5649 0.820312 0.65625 18.7289 0.65625 40.8203V476.82C0.65625 498.912 18.5649 516.82 40.6563 516.82H237.437C259.528 516.82 277.437 498.912 277.437 476.82V256.586Z"
            fill={isGrayBorder ? "#BDBDBD" : "#EEEEEE"}
          />
        </svg>
      ) : (
        <svg
          width="414"
          className="absolute  -right-1/3 scale-[1.035] top-0 z-0"
          height="517"
          viewBox="0 0 414 517"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            className="transition-colors duration-300"
            d="M408.284 237.314L288.214 21.3813C281.157 8.69012 267.776 0.820312 253.255 0.820312H40C17.9086 0.820312 0 18.7289 0 40.8203V476.82C0 498.912 17.9086 516.82 40 516.82H253.057C267.683 516.82 281.143 508.837 288.157 496.003L408.425 275.936C415.008 263.89 414.955 249.311 408.284 237.314Z"
            fill={isBlueBorder ? "#017E9D" : "#BAE5F0"}
          />
        </svg>
      )}
      {noInEffective || isAddOn ? null : (
        <Button
          text="If Ineffective"
          onClick={inEffectiveClick}
          type={isBlueBorder ? "secondary" : "primary"}
          className="!rounded-[20px] h-[32px] max-w-max transform -translate-y-1/2 absolute z-10 top-[50%]  right-[-150px]"
        />
      )}
    </div>
  );
};

export default PharmacologicalCard;
